module.exports = __webpack_public_path__ + "static/media/editor-grey.fb0c63c9.svg";